import FormControl from '@mui/material/FormControl'
import { SelectChangeEvent } from '@mui/material/Select'
import React, { useEffect, useState, useRef } from 'react'
import { useExclusiveMenu } from '../../hooks/useExclusiveMenu'
import Select from 'react-select'
import { useTranslation } from 'react-i18next'
import { incyiaSelectStyles } from '../../utils/incyiaSelectStyles'
import { getAllPlans } from '../../api/planApi'
import { useAsyncOptions } from '../../hooks/useAsyncOptions'
import { createOptionProps } from './CreateOptionMenu'

interface SelectPlanProps {
  value: string
  onChange: (event: SelectChangeEvent<string>, child?: React.ReactNode) => void
  disabled?: boolean
  /** Only list the plans of this mission. */
  MissionId?: string
  onCreateNew?: (search: string) => void
  reloadKey?: number
}

const SelectPlan: React.FC<SelectPlanProps> = ({
  value,
  onChange,
  disabled = false,
  MissionId,
  onCreateNew,
  reloadKey = 0,
}) => {
  const menu = useExclusiveMenu()
  const { t } = useTranslation()
  const { data: plans, status, retry } = useAsyncOptions(async () => {
    const response = await getAllPlans({ page: 1, pageSize: 200 })
    return response.plans ?? []
  }, [reloadKey])

  const containerRef = useRef<HTMLDivElement>(null)


  const selectOptions =
    status === 'ready'
      ? (plans ?? [])
          .filter((plan) => !MissionId || String(plan.MissionId) === String(MissionId))
          .map((plan) => ({
          value: plan._id,
          label: plan.PlanName,
        }))
      : []

  const selectedOption =
    selectOptions.find((opt) => opt.value === value) || null

  const handleSelectChange = (selected: any) => {
    const event = {
      target: { value: selected ? selected.value : '' },
    } as SelectChangeEvent<string>
    onChange(event)
  }

  return (
    <div ref={containerRef} style={{ width: '100%', position: 'relative' }}>
      <FormControl fullWidth style={{ width: '100%' }}>
        <Select
          value={selectedOption}
          onChange={handleSelectChange}
          options={selectOptions}
          placeholder={
            status === 'loading'
              ? t('selectOptions.loading')
              : t('Treatment plan', { defaultValue: 'Plan' })
          }
          styles={incyiaSelectStyles}
          isLoading={status === 'loading'}
          isDisabled={disabled || status === 'loading'}
          noOptionsMessage={() =>
            status === 'error'
              ? t('selectOptions.failed')
              : t('tables.noData')
          }
          {...menu}
          isMulti={false}
          {...createOptionProps(
            onCreateNew && { label: t('quickCreate.new.plan'), onCreate: onCreateNew }
          )}
        />
      </FormControl>
      {status === 'error' ? (
        <button
          type="button"
          onClick={retry}
          style={{
            marginTop: 6,
            background: 'none',
            border: 'none',
            padding: 0,
            color: '#076B5C',
            cursor: 'pointer',
            fontFamily: 'Lato, sans-serif',
            fontSize: 13,
          }}
        >
          {t('selectOptions.retry')}
        </button>
      ) : null}
    </div>
  )
}

export default SelectPlan
